<div class="patient-order-details-page">
  <div *ngIf="!loaded">
    <h3 style="text-align: center">LOADING ORDER</h3>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div *ngIf="loaded" class="patient-order-details">
    <div
      class="order-details-toolbar"
      [class.order-details-toolbar-embedded]="embedded"
    >
      <button mat-button type="button" (click)="navigateBack()">
        <mat-icon>{{ embedded ? 'close' : 'arrow_back' }}</mat-icon>
        <span>{{ embedded ? 'CLOSE' : 'BACK TO PATIENT' }}</span>
      </button>
      <div class="order-details-toolbar-center">
        <button
          mat-stroked-button
          type="button"
          class="internal-note-button"
          [class.has-note]="hasInternalNote"
          (click)="openInternalNoteDialog()"
        >
          <mat-icon>visibility</mat-icon>
          <span>INTERNAL NOTE</span>
        </button>
      </div>
      <div class="order-details-toolbar-right">
        <span
          class="invoice-number"
          *ngIf="isQuoteDisplay"
          [style.color]="currentStore?.headerColor || '#c62828'"
        >
          QUOTE
        </span>
        <span
          class="invoice-number"
          *ngIf="!isQuoteDisplay && invoiceNumberDisplay"
          [style.color]="currentStore?.headerColor || '#c62828'"
        >
          <span class="invoice-number-label">No.</span>
          {{ invoiceNumberDisplay }}
          <span class="fulfillment-ship-badge" *ngIf="isShipFulfillment">SHIP</span>
        </span>
        <div class="order-status-row">
          <app-log-menu
            [order]="orderFormGroup"
            [small]="true"
            [alwaysShow]="true"
          ></app-log-menu>
          <span class="order-status-button">{{ orderStatusLabel }}</span>
        </div>
      </div>
    </div>

    <div
      fxLayout="row"
      fxLayoutAlign="start end"
      fxLayoutGap="10px"
      class="patient-order-header"
      [formGroup]="orderFormGroup"
    >
      <div fxFlex="0 0 75px">PATIENT:</div>
      <div fxFlex="1 1 calc(35%-75px)" class="patient-name">
        {{ patient?.lastName }}, {{ patient?.firstName }}
      </div>
      <div fxFlex="0 0 50px" style="text-align: center">CELL:</div>
      <div fxFlex="1 1 calc(25%-50px)">{{ patient?.cell | phone }}</div>
    </div>

    <mat-accordion class="order-details-accordion" multi>
      <mat-expansion-panel [expanded]="true" (opened)="panelOpenStateFrameDetails = true" (closed)="panelOpenStateFrameDetails = false">
        <mat-expansion-panel-header [style.background-color]="panelOpenStateFrameDetails ? currentStore?.headerColor : null">
          <mat-panel-title>FRAME DETAILS</mat-panel-title>
        </mat-expansion-panel-header>
        <app-frame-details
          [orderForm]="orderFormGroup"
          [patient]="patient"
          [authorized]="authorized"
          (saveOrder)="onSave($event.destination)"
        ></app-frame-details>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelOpenStatePrescription = true" (closed)="panelOpenStatePrescription = false">
        <mat-expansion-panel-header [style.background-color]="panelOpenStatePrescription ? currentStore?.headerColor : null">
          <mat-panel-title>PRESCRIPTION</mat-panel-title>
        </mat-expansion-panel-header>
        <app-prescription-details
          [orderForm]="orderFormGroup"
          [patient]="patient"
          (saveOrder)="onSave($event.destination)"
        ></app-prescription-details>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelOpenStateLens = true" (closed)="panelOpenStateLens = false">
        <mat-expansion-panel-header [style.background-color]="panelOpenStateLens ? currentStore?.headerColor : null">
          <mat-panel-title>LENS</mat-panel-title>
        </mat-expansion-panel-header>
        <app-lens-details
          [orderForm]="orderFormGroup"
          (saveOrder)="onSave($event.destination)"
        ></app-lens-details>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelOpenStateRepair = true" (closed)="panelOpenStateRepair = false">
        <mat-expansion-panel-header [style.background-color]="panelOpenStateRepair ? currentStore?.headerColor : null">
          <mat-panel-title>REPAIR / WARRANTY</mat-panel-title>
        </mat-expansion-panel-header>
        <app-repair-details
          [orderForm]="orderFormGroup"
          (saveOrder)="onSave($event.destination)"
        ></app-repair-details>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
